/**
 * Helper functions for the Customers Table
 */

export const getMemberName = (id) => {
  if (!id) return "Unassigned";
  if (typeof id === 'object') {
    const name = id.name || `${id.firstName || ""} ${id.lastName || ""}`.trim();
    return name || "Unknown Member";
  }
  return "Unknown";
};

export const formatDate = (date) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleString('en-IN', {
    day: '2-digit', month: 'short', year: '2-digit',
    hour: '2-digit', minute: '2-digit'
  });
};

export const getReferenceLabel = (l) => {
  const raw = String(l.referenceType || "").toLowerCase().trim();
  const isSystem = ["manual", "bulk import", "website", "csv import"].includes(raw);
  const cleaned = isSystem ? "" : (l.referenceType || "");
  return cleaned || (l.source === "Bulk Import" ? "Direct" : "—");
};

export const getLastNote = (l, lastActivity) => {
  const statusToField = {
    connected: 'connectedNote',
    not_connected: 'notConnectedNote',
    interested: 'interestedNote',
    not_interested: 'notInterestedNote',
    not_reachable: 'notReachableNote',
    converted: 'convertedNote',
    contact_later: 'contactLaterNote',
    drop: 'droppedNote',
    new: 'notes'
  };
  
  const field = statusToField[l.status] || 'notes';
  return l.lastActivityNote || l[field] || l.lastCallNote || "No notes yet";
};
